<template>
  <div
    :class="['tag', type, size, round ? 'round': '', outline ? 'outline' : '']"
    :color="bgColor"
    :style="{color: color}">
    {{text}}
    <slot></slot>
    <a class="font-bold text-black ml-1" @click="onTagClose">
      <span>
        <i aria-label="icon: close" tabindex="-1" class="anticon anticon-close"><svg viewBox="64 64 896 896" data-icon="close" width="8px" height="8px" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path></svg></i>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    type: {
      type: String,
      default: 'default'
    },
    outline: {
      type: Boolean,
      default: false
    },
    round: Boolean,
    size: {
      type: String,
      default: ''
    },
    closable: Boolean,
    color: String,
    bgColor: String,
    to: Function
  },
  methods: {
    handleClick() {
      this.$emit('to')
    },
    onTagClose() {
      this.$emit('deleteTag')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";

.tag ::v-deep .anticon-close {
  vertical-align: middle;
  background: #A8AAAD;
  color: #fff;
  border-radius: 999px;
  padding: 4px;
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 1px;
}
.tag.small ::v-deep .anticon-close {
  padding: 3px;
  font-size: 10px;
}
</style>